export default "__VITE_ASSET__33075f4f__"